import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from "rxjs";

interface TranscriptLine {
    speaker: string;
    text: string;
}

@Component({
    selector: 'app-call-transcript',
    templateUrl: './call-transcript.component.html',
    styleUrls: ['./call-transcript.component.scss'],
})
export class CallTranscriptComponent implements OnInit {

    public onClose: Subject<any>;
    transcriptLines: TranscriptLine[] = [];
    data: any;

    constructor(public bsModalRef: BsModalRef) { }

    ngOnInit() {
        if (!this.data) return;

        const rawLines = this.data.split('\n');

        for (let line of rawLines) {
            line = line.trim();

            if (!line) {
                continue;
            }

            if (line.startsWith('User:')) {
                this.transcriptLines.push({
                    speaker: 'User',
                    text: line.substring(5).trim()
                });
            } else if (line.startsWith('Agent:')) {
                this.transcriptLines.push({
                    speaker: 'Agent',
                    text: line.substring(6).trim()
                });
            } else {
                this.transcriptLines.push({
                    speaker: '',
                    text: line
                });
            }
        }
    }

    closePanel() {
        this.bsModalRef.hide();
        if (this.onClose) {
            this.onClose.next('close');
            this.onClose.complete();
        }
    }
}